import { Box, Button, Grid, makeStyles } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { HeaderBlock } from '../../components/header-block/HeaderBlock'
import ListableCard from '../../components/listable-card/ListableCard'
import { Loading } from '../../components/loading/Loading'
import PageContainer from '../../components/page-container/PageContainer'
import { DeleteModal } from '../../containers/delete-modal/DeleteModal'
import GenericPickerModal from '../../containers/generic-picker-modal/GenericPickerModal'
import { updateOutOfStockList, getOutOfStockProducts } from '../../state/actions/OutOfStockActions'
import { getProducts, getProductsForIds } from '../../state/actions/ProductActions'
import { getTargetGroup } from '../../state/actions/TargetGroupActions'
import { useTranslation } from 'react-i18next'
import { SalesOrgIds } from '../../state/constants/SalesOrgIds'
import ProductPickerModal from 'containers/generic-picker-modal/ProductPickerModal'

const useStyles = makeStyles({
    listableCard: {
        margin: "30px"
    },
    contentGrid: {
        margin: "16px"
    }
})

function ViewOutOfStockPage(props) {

    const currentOutOfStock = useSelector(state => state.OutOfStockReducer.currentOutOfStockList)
    const currentTargetGroup = useSelector(state => state.TargetGroupReducer.currentTargetGroup)

    const products = useSelector(state => state.ProductReducer.products)

    const [t, i18n] = useTranslation()
    const classes = useStyles()
    const dispatch = useDispatch()

    const [loading, setLoading] = useState(false)
    const [loadingProducts, setLoadingProducts] = useState(false)
    const [outOfStockModalOpen, setOutOfStockModalOpen] = useState(false)
    const [deleteModalOpen, setDeleteModalOpen] = useState(false)
    const [oOSToDelete, setOOSToDelete] = useState([])
    const [newData, setNewData] = useState(false)

    useEffect(() => {
        setLoading(true)
        const outOfStockId = props.match.params.oosId
        dispatch(getTargetGroup(outOfStockId, () => {
            setLoading(false)
            setNewData(true)
        }))
    }, [])

    useEffect(() => {
        setLoadingProducts(true)
        dispatch(getProductsForIds(currentOutOfStock, () => {
            setLoadingProducts(false)
        }))
    }, [currentOutOfStock])

    useEffect(() => {
        if (newData === true) {
            setLoadingProducts(true)
            dispatch(getOutOfStockProducts(currentTargetGroup.id, () => {
                setNewData(false)
            }))
        }
    }, [newData])

    function handleOutOfStockSelection(items) {

        const values = currentOutOfStock.concat(items)

        const data = {
            DistributorId: currentTargetGroup.id,
            ProductIds: values
        }

        setOutOfStockModalOpen(false)

        dispatch(updateOutOfStockList(data, () => {
            setNewData(true)
        }))
    }

    function handleOutOfStockDeletion(items) {
        const itemIds = items.map(item => item.id);
        const values = currentOutOfStock.filter(value => !itemIds.includes(value));

        const data = {
            DistributorId: currentTargetGroup.id,
            ProductIds: values
        }

        setDeleteModalOpen(false)

        dispatch(updateOutOfStockList(data, () => {
            setNewData(true)
        }))
    }

    function getOutOfStockProductList(productIds) {

        if (productIds !== undefined) {
            return productIds.map(productId => {
                const outOfStockItem = products[productId];

                if (outOfStockItem !== undefined) {
                    return { id: outOfStockItem.id, Name: outOfStockItem.ProductDisplayName != null ? outOfStockItem.ProductDisplayName : outOfStockItem.ProductName };
                }

                return {};
            });
        }

        return [];
    }

    function getContentGrid() {
        const cards = [
            {
                add: t('common.add'),
                buttonAction: () => {
                    setOutOfStockModalOpen(true)
                },
                handleDelete: (items) => {
                    setDeleteModalOpen(true)
                    setOOSToDelete(items)
                },
                isLoading: () => { return loadingProducts },
                title: t('oos.oos-list'),
                emptyPlaceholder: t('oos.no-products-are-out-of-stock'),
                data: getOutOfStockProductList(Object.values(currentOutOfStock)),
                type: "out-of-stock"
            },
        ];

        return (
            <Box className={classes.contentGrid}>
                <Grid container spacing={3}>
                    {cards.map(card => {
                        if (card.type === "title") {
                            return (
                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <div className={classes.sectionHeader}>{card.title}</div>
                                </Grid>
                            );
                        }

                        return (
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <ListableCard
                                    className={classes.listableCard}
                                    actionButton={[
                                        <Button
                                            onClick={card.buttonAction}
                                            variant="outlined"
                                            color="secondary"
                                        >
                                            {card.add}
                                        </Button>
                                    ]}
                                    addLabel={card.add}
                                    isLoading={card.isLoading()}
                                    title={card.title}
                                    emptyPlaceholder={card.emptyPlaceholder}
                                    handleDelete={card.handleDelete}
                                    data={card.data == null ? [] : card.data}
                                />
                            </Grid>
                        );
                    })}
                </Grid>
            </Box>
        );
    }

    return (
        <Box>
            <HeaderBlock title={t('oos.out-of-stock-list', { name: (currentTargetGroup.DisplayName ? currentTargetGroup.DisplayName : "") })} />

            <DeleteModal
                handleCancel={() => {
                    setDeleteModalOpen(false)
                    setOOSToDelete([])
                }}
                handleDone={data => {
                    handleOutOfStockDeletion(data);
                }}
                data={getOutOfStockProductList(oOSToDelete)}
                open={deleteModalOpen}
            />

            <ProductPickerModal
                handleProductSelection={selectedProducts => handleOutOfStockSelection(selectedProducts)}
                productModalOpen={outOfStockModalOpen}
                selected={Object.values(currentOutOfStock)}
                setProductModalOpen={() => setOutOfStockModalOpen(false)}
            />

            <PageContainer>
                {loading ? <Loading /> : getContentGrid()}
            </PageContainer>
        </Box>
    )
}

ViewOutOfStockPage.propTypes = {

}

export default ViewOutOfStockPage

